<template>
  <div>
    <button
      class="default-btn red slim small"
      @click="show = true"
    ><v-icon>mdi-delete</v-icon></button>

    <v-dialog v-model="show">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          Are you sure you want to delete this deal? This cannot be undone.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <button
            class="default-btn text"
            @click="show = false"
          >Cancel</button>

          <button
            class="default-btn red"
            @click="handleDelete"
          >Delete</button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DialogDeleteDeal',
  props: {
    dealId: String,
  },
  data: () => ({
    show: false,
  }),
  computed: {
    ...mapGetters('feathers', ['apiDeals']),
  },
  methods: {
    async handleDelete () {
      try {
        await this.apiDeals.remove(this.dealId)
        this.$emit('deleted')
        this.show = false

        this.addAlert({ message: 'Successfully deleted the deal' })
      } catch (error) {
        this.addAlert({
          type: 'error',
          message: `There was an error deleting the deal: ${error.message}`,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-dialog {
    width: 350px;
    max-width: 90vw;
  }
}

</style>
